export default function PHP_decbin() {
  return (
    <div>
      <h1>PHP_decbin</h1>
    </div>
  );
}
